module.exports = __webpack_public_path__ + "static/unwomen-case-study-ab854859f6d3a0d84cececfe55126b50.webp";